import translate from '@/utils/genTable/multilanguageHelper.js'
export default {
  data() {
    return {}
  },
  async mounted() {},
  computed: {},
  methods: {
    async setBreadcrumbs() {
      const urlRoute = this.$route.fullPath.slice(1)
      const navigationJson = await import('../../resource/navigation.json')
      const navigationData = navigationJson.navList

      let routeElements = urlRoute.split('/')
      let nestingLevel = routeElements.length

      let elementsForNavigation

      if (nestingLevel == 1) {
        navigationData.forEach(parent => {
          if (parent.routeName) {
            if (
              parent.routeName.toLocaleLowerCase() ==
              routeElements[0].toLocaleLowerCase()
            ) {
              elementsForNavigation = [
                {
                  text: translate(parent.name, parent.translatePath),
                  disabled: true
                }
              ]
            }
          }
        })
      } else {
        navigationData.forEach(parent => {
          parent.data.forEach(child => {
            if (
              child.routeName.toLocaleLowerCase() ==
                routeElements[0].toLocaleLowerCase() &&
              child.slug.toLocaleLowerCase() ==
                routeElements[1].toLocaleLowerCase()
            ) {
              elementsForNavigation = [
                {
                  text: translate(parent.name, parent.translatePath),
                  disabled: true
                },
                {
                  text: translate(child.content, parent.translatePath),
                  disabled: true
                }
              ]
            }
          })
        })
      }
      return elementsForNavigation
    }
  }
}
